module.exports = ":host .in-modal svg{margin-bottom:200px}\n"